import CompaniesHome from './CompaniesHome';

export default CompaniesHome;
